module.exports = __webpack_public_path__ + "static/img/brand-2.d549f65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/brand-2.png
// module id = OOEG
// module chunks = 2